(function () {
  'use strict';

  function initSmartHeader() {
    var header = document.querySelector('[data-header]'); if (!header) return;
    var lastY = window.scrollY, ticking = false, HIDE_AFTER = 140, DELTA = 6;
    function update() {
      var y = window.scrollY, diff = y - lastY;
      if (y < HIDE_AFTER) header.classList.remove('header-hidden');
      else if (diff > DELTA) header.classList.add('header-hidden');
      else if (diff < -DELTA) header.classList.remove('header-hidden');
      lastY = y; ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]'); var nav = document.querySelector('[data-header-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
      if (!open) nav.querySelectorAll('.nav-item.is-expanded').forEach(function (i) { i.classList.remove('is-expanded'); });
    });
    nav.querySelectorAll('.nav-item.has-dropdown > span').forEach(function (span) {
      span.addEventListener('click', function (e) {
        if (!nav.classList.contains('is-open')) return;
        e.preventDefault();
        var parent = span.parentElement;
        var wasOpen = parent.classList.contains('is-expanded');
        nav.querySelectorAll('.nav-item.is-expanded').forEach(function (i) {
          if (i !== parent) i.classList.remove('is-expanded');
        });
        parent.classList.toggle('is-expanded', !wasOpen);
      });
    });
  }

  function initCartDrawer() {
    var drawer = document.getElementById('CartDrawer'); if (!drawer) return;
    var openTriggers = document.querySelectorAll('[data-cart-open]');
    var closeTriggers = drawer.querySelectorAll('[data-cart-close]');
    function open(e) {
      if (window.shopifyCartType !== 'page' && (!e || e.target.dataset.cartOpen !== undefined)) { e && e.preventDefault(); }
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      refreshCart();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    openTriggers.forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); open(e); }); });
    closeTriggers.forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.__openCartDrawer = open;
    window.__closeCartDrawer = close;
  }

  function refreshCart() { fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); }).catch(function () {}); }

  function renderCart(cart) {
    var body = document.querySelector('[data-cart-body]'); var count = document.querySelector('[data-cart-count]');
    if (count) count.textContent = cart.item_count;
    if (!body) return;
    if (cart.item_count === 0) { body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>'; return; }
    var threshold = 6500;
    var remaining = Math.max(0, threshold - cart.total_price);
    var pct = Math.min(100, (cart.total_price / threshold) * 100);
    var html = '';
    html += '<div class="cart-shipping">';
    if (remaining > 0) html += '<p class="cart-shipping-text">Spend <strong>' + formatMoney(remaining) + '</strong> more to unlock free shipping</p>';
    else html += '<p class="cart-shipping-text cart-shipping-text--complete"><strong>🎉 You\'ve unlocked free shipping!</strong></p>';
    html += '<div class="cart-shipping-bar"><div class="cart-shipping-fill" style="width:' + pct + '%"></div></div>';
    html += '<p class="cart-shipping-threshold">Free shipping on orders $65+</p></div>';
    html += '<div class="cart-drawer__items">';
    cart.items.forEach(function (item, idx) {
  var lineIndex = idx + 1;
  var isSub = !!item.selling_plan_allocation;
  var planName = isSub ? item.selling_plan_allocation.selling_plan.name : '';
  var origLine = item.original_line_price;
  var finalLine = item.final_line_price;
  var showStrike = isSub && origLine > finalLine;

  html += '<div class="cart-drawer__item' + (isSub ? ' cart-drawer__item--sub' : '') + '">';
  if (item.image) html += '<img src="' + item.image + '" alt="" class="cart-drawer__item-img">';
  html += '<div class="cart-drawer__item-info">';
  html += '<a href="' + item.url + '" class="cart-drawer__item-name">' + item.product_title + '</a>';
  if (isSub) {
    html += '<div class="cart-drawer__item-sub" style="color:#7B6A91;font-size:.78rem;font-weight:500;margin:4px 0 2px;letter-spacing:.02em">';
    html += '<span style="display:inline-block;width:6px;height:6px;border-radius:50%;background:#7B6A91;margin-right:6px;vertical-align:middle"></span>';
    html += 'Subscribe &amp; save · ' + planName;
    html += '</div>';
    html += '<div style="color:#999;font-size:.72rem;margin:0 0 4px;letter-spacing:.01em">Cancel anytime</div>';
  }
  html += '<div class="cart-drawer__item-price">' + formatMoney(finalLine);
  if (showStrike) html += ' <span style="text-decoration:line-through;color:#999;font-size:.85em;margin-left:6px;font-weight:normal">' + formatMoney(origLine) + '</span>';
  html += '</div>';
  html += '<div class="cart-drawer__item-actions"><div class="cart-qty-control" data-line="' + lineIndex + '">';
  html += '<button type="button" class="cart-qty-btn" data-qty-down aria-label="Decrease quantity">−</button>';
  html += '<span class="cart-qty-value">' + item.quantity + '</span>';
  html += '<button type="button" class="cart-qty-btn" data-qty-up aria-label="Increase quantity">+</button></div>';
  html += '<button type="button" class="cart-drawer__item-remove" data-line="' + lineIndex + '" data-qty-remove>Remove</button>';
  html += '</div></div></div>';
});
    html += '</div>';
    html += '<div class="cart-discount"><details class="cart-discount-toggle"><summary class="cart-discount-summary">Have a discount code?</summary>';
    html += '<div class="cart-discount-form" data-discount-form><div class="cart-discount-row">';
    html += '<input type="text" class="cart-discount-input" placeholder="Enter code" data-discount-input>';
    html += '<button type="button" class="cart-discount-apply" data-discount-apply>Apply</button></div>';
    html += '<p class="cart-discount-note" data-discount-note></p></div>';
    html += '<div class="cart-discount-applied" data-discount-applied hidden><div class="cart-discount-chip">';
    html += '<span class="cart-discount-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg></span>';
    html += '<div class="cart-discount-info"><span class="cart-discount-code" data-discount-code-display></span>';
    html += '<span class="cart-discount-status">Applies at checkout</span></div>';
    html += '<button type="button" class="cart-discount-remove" data-discount-remove aria-label="Remove discount code">';
    html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    html += '</button></div></div></details></div>';
    html += '<div class="cart-drawer__footer"><div class="cart-drawer__subtotal"><span>Subtotal</span><strong>' + formatMoney(cart.total_price) + '</strong></div>';
    html += '<a href="/checkout" class="btn btn-primary cart-drawer__checkout" data-checkout-btn>Check Out</a></div>';
    body.innerHTML = html;
    body.querySelectorAll('[data-qty-up]').forEach(function (btn) { btn.addEventListener('click', function () { changeCartLine(btn, 1); }); });
    body.querySelectorAll('[data-qty-down]').forEach(function (btn) { btn.addEventListener('click', function () { changeCartLine(btn, -1); }); });
    body.querySelectorAll('[data-qty-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () { var line = parseInt(btn.getAttribute('data-line'), 10); updateCartLine(line, 0); });
    });
    var form = body.querySelector('[data-discount-form]'), applied = body.querySelector('[data-discount-applied]'),
        codeDisplay = body.querySelector('[data-discount-code-display]'), applyBtn = body.querySelector('[data-discount-apply]'),
        removeBtn = body.querySelector('[data-discount-remove]'), checkout = body.querySelector('[data-checkout-btn]');
    var savedCode = '';
    try { savedCode = sessionStorage.getItem('tbh_discount_code') || ''; } catch (e) {}
    if (savedCode && form && applied && codeDisplay) {
      codeDisplay.textContent = savedCode;
      form.setAttribute('hidden', ''); applied.removeAttribute('hidden');
      if (checkout) checkout.href = '/checkout?discount=' + encodeURIComponent(savedCode);
    }
    if (applyBtn) applyBtn.addEventListener('click', function () {
      var input = body.querySelector('[data-discount-input]'), code = (input.value || '').trim(), note = body.querySelector('[data-discount-note]');
      if (!code) { note.textContent = 'Enter a code first.'; return; }
      if (codeDisplay) codeDisplay.textContent = code;
      if (form) form.setAttribute('hidden', '');
      if (applied) applied.removeAttribute('hidden');
      if (checkout) checkout.href = '/checkout?discount=' + encodeURIComponent(code);
      try { sessionStorage.setItem('tbh_discount_code', code); } catch (e) {}
    });
    if (removeBtn) removeBtn.addEventListener('click', function () {
      var input = body.querySelector('[data-discount-input]'), note = body.querySelector('[data-discount-note]');
      if (input) input.value = '';
      if (note) note.textContent = '';
      if (applied) applied.setAttribute('hidden', '');
      if (form) form.removeAttribute('hidden');
      if (checkout) checkout.href = '/checkout';
      try { sessionStorage.removeItem('tbh_discount_code'); } catch (e) {}
    });
  }

  function changeCartLine(btn, delta) {
    var control = btn.closest('[data-line]'); if (!control) return;
    var line = parseInt(control.getAttribute('data-line'), 10);
    var current = parseInt(control.querySelector('.cart-qty-value').textContent, 10);
    updateCartLine(line, Math.max(0, current + delta));
  }

  function updateCartLine(line, quantity) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: quantity }) })
      .then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); }).catch(function () {});
  }

  function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }

  function initProductForm() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var data = new FormData(form);
        fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
          .then(function (r) { return r.json(); }).then(function () {
            if (window.__openCartDrawer) window.__openCartDrawer();
            else window.location.href = window.routes.cart_url;
          }).catch(function () { alert(window.cartStrings.error); });
      });
    });
  }

  function initQtyControls() {
    document.querySelectorAll('[data-qty-input]').forEach(function (input) {
      var wrap = input.closest('.qty-control'); if (!wrap) return;
      var dec = wrap.querySelector('[data-qty-decrease]'), inc = wrap.querySelector('[data-qty-increase]');
      if (dec) dec.addEventListener('click', function () { input.value = Math.max(1, parseInt(input.value) - 1); syncFormQty(input); });
      if (inc) inc.addEventListener('click', function () { input.value = parseInt(input.value) + 1; syncFormQty(input); });
      input.addEventListener('change', function () { syncFormQty(input); });
    });
  }

  function syncFormQty(input) {
    var form = input.closest('form') || document.querySelector('[data-product-form]'); if (!form) return;
    var hidden = form.querySelector('[data-form-qty]');
    if (hidden) hidden.value = input.value;
  }

  function initSubscribe() {
  var opts = document.querySelectorAll('.subscribe-option input');
  if (!opts.length) return;
  var sellingPlanField = document.querySelector('[data-selling-plan]');
  var atcBtn = document.querySelector('.btn-add-to-cart');
  var stickyPrice = document.querySelector('.sticky-atc-price');
  var onetimeInput = document.querySelector('[data-purchase-onetime]');
  var subInput = document.querySelector('[data-purchase-subscription]');
  function priceFromLabel(input) {
    if (!input) return '';
    var span = input.parentElement.querySelector('.subscribe-label span');
    if (!span) return '';
    return span.textContent.split('·')[0].trim();
  }
  var onetimePrice = priceFromLabel(onetimeInput);
  var subPrice = priceFromLabel(subInput);
  function setPrice(price) {
    if (atcBtn && !atcBtn.disabled && price) {
      atcBtn.textContent = 'Add to Cart — ' + price;
    }
    if (stickyPrice && price) stickyPrice.textContent = price;
  }
  opts.forEach(function (input) {
    input.addEventListener('change', function () {
      document.querySelectorAll('.subscribe-option').forEach(function (o) { o.classList.remove('subscribe-option--active'); });
      input.closest('.subscribe-option').classList.add('subscribe-option--active');
      if (sellingPlanField) {
        if (input.value === 'subscription' && input.dataset.sellingPlanId) sellingPlanField.value = input.dataset.sellingPlanId;
        else sellingPlanField.value = '';
      }
      setPrice(input.value === 'subscription' ? subPrice : onetimePrice);
    });
  });
}

  function initStickyATC() {
    var sticky = document.querySelector('[data-sticky-atc]'); var trigger = document.querySelector('.btn-add-to-cart');
    if (!sticky || !trigger) return;
    var stickyBtn = sticky.querySelector('[data-sticky-atc-btn]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      var form = document.querySelector('[data-product-form]');
      if (form) form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { sticky.classList.toggle('is-visible', !entry.isIntersecting); });
    }, { rootMargin: '0px 0px -100px 0px' });
    observer.observe(trigger);
  }

  function initProductGallery() {
    var gallery = document.querySelector('[data-gallery]'); if (!gallery) return;
    var slides = gallery.querySelectorAll('[data-slide]'), thumbs = gallery.querySelectorAll('[data-gallery-thumb]'),
        prevBtn = gallery.querySelector('[data-gallery-prev]'), nextBtn = gallery.querySelector('[data-gallery-next]'),
        counter = gallery.querySelector('[data-gallery-current]');
    if (slides.length <= 1) return;
    var current = 0;
    function show(idx) {
      if (idx < 0) idx = slides.length - 1;
      if (idx >= slides.length) idx = 0;
      current = idx;
      for (var i = 0; i < slides.length; i++) slides[i].classList.toggle('is-active', i === current);
      for (var j = 0; j < thumbs.length; j++) thumbs[j].classList.toggle('is-active', j === current);
      if (counter) counter.textContent = (current + 1).toString();
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });
    thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { show(i); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
    });
  }

  // Force-reveal Judge.me carousels that get stuck hidden
  function initJudgemeReveal() {
    function unhide(wrapper) {
      var carousel = wrapper.querySelector('.jdgm-carousel');
      if (carousel && carousel.children.length > 0) {
        wrapper.classList.remove('jdgm-hidden');
        carousel.classList.remove('jdgm-hidden');
        wrapper.style.display = 'block';
      }
    }
    function setupAll() {
      document.querySelectorAll('.jdgm-carousel-wrapper').forEach(function (w) {
        unhide(w);
        var obs = new MutationObserver(function () { unhide(w); });
        obs.observe(w, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        setTimeout(function () { obs.disconnect(); }, 60000);
      });
    }
    setupAll();
    setTimeout(setupAll, 2000);
    setTimeout(setupAll, 5000);
  }

  function init() {
    initSmartHeader(); initMobileMenu(); initCartDrawer(); initProductForm();
    initQtyControls(); initSubscribe(); initStickyATC(); initProductGallery(); initJudgemeReveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
